import React, { useState } from "react";
import {
  CmSheetStateMachine,
  CollaboratorCmSheet,
} from "../../../../../../types/api/collaborators.type";
import {
  CmSheetEventEnum,
  CmSheetStateEnum,
} from "../../../../../../constants/AppConstants";
import {
  CONFIRM_CM_SHEET_LABEL,
  CONFIRM_CM_SHEET_MESSAGE,
} from "../../../../../../constants/Dictionary";
import { PopupConfirm } from "../../../../../../components/PopupConfirm/PopupConfirm";
import { ReactComponent as MessageCheckIcon } from "../../../../../../icons/messageCheck.svg";
import {
  Button,
  ButtonSizes,
} from "../../../../../../components/core/Button/Button";
import { StyledButtonFooterConfirmCmSheet } from "./ConfirmCmSheetChip.styled";
import { useUpdateCmSheetStateMachine } from "../../../../../../hooks/cmSheet/stateMachine.hook";
interface ConfirmCmSheetChipProps {
  cmSheetInfo: CollaboratorCmSheet;
  cmSheetStateMachineInfo: CmSheetStateMachine;
}

export const ConfirmCmSheetChip = ({
  cmSheetInfo,
  cmSheetStateMachineInfo,
}: ConfirmCmSheetChipProps) => {
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const { updateCmSheetStateMachine, isUpdating } =
    useUpdateCmSheetStateMachine(cmSheetInfo.id);

  const handleConfirm = async () => {
    await updateCmSheetStateMachine({
      event: CmSheetEventEnum.OK_PRESA_VISIONE,
    });
    setShowPopup(false);
  };

  const isConfirmSheetEnabled = () => {
    if (
      [
        CmSheetStateEnum.DRAFT,
        CmSheetStateEnum.INTERMEDIATE_EVALUATION,
        CmSheetStateEnum.FINAL_FEEDBACK,
        CmSheetStateEnum.FINAL_CALIBRATION,
      ].includes(cmSheetStateMachineInfo.currentState) &&
      cmSheetStateMachineInfo.isRevisionRequestSent
    ) {
      return true;
    }

    return false;
  };

  return (
    <StyledButtonFooterConfirmCmSheet>
      <Button
        label={CONFIRM_CM_SHEET_LABEL}
        onClick={() => setShowPopup(true)}
        icon={<MessageCheckIcon />}
        size={ButtonSizes.REGULAR}
        disabled={!isConfirmSheetEnabled()}
      />
      <PopupConfirm
        isOpen={showPopup}
        onConfirm={handleConfirm}
        onCancel={() => setShowPopup(false)}
        label={CONFIRM_CM_SHEET_LABEL}
        popupText={CONFIRM_CM_SHEET_MESSAGE}
        isLoading={isUpdating}
      />
    </StyledButtonFooterConfirmCmSheet>
  );
};
